<div class="container-fluid delivery-page">
    <div class="row">
        <div class="col-12">
            <div class="page-title">
                <h5>{{ 'delivery.title' | translate }}</h5>
            </div>
        </div>
    </div>

    <section class="main-container">
        <div class="main container">

            <!-- SHIPPING ADDRESS SECTION -->
            <div class="row mb-4">
                <div class="col-12">
                    <div class="card address-section">
                        <div class="card-header">
                            <h6 class="mb-0">
                                <i class="fa fa-map-marker-alt me-2"></i>
                                {{ 'delivery.shipping_address' | translate }}
                            </h6>
                        </div>

                        <div class="card-body">
                            <!-- IF ADDRESS IS LOADING -->
                            <div *ngIf="addressLoading" class="text-center py-3">
                                <div class="spinner-border spinner-border-sm" role="status">
                                    <span class="visually-hidden">{{ 'common.loading' | translate }}...</span>
                                </div>
                            </div>

                            <!-- IF PRIMARY ADDRESS EXISTS AND NOT EDITING -->
                            <div *ngIf="!addressLoading && primaryAddress && !showAddressForm">
                                <div class="row align-items-center g-3">
                                    <div class="col-12 col-md-9">
                                        <div class="address-details">
                                            <p class="mb-1"><strong>{{ primaryAddress.name }}</strong></p>
                                            <p class="mb-1">{{ primaryAddress.addressLine1 }}</p>
                                            <p class="mb-1" *ngIf="primaryAddress.addressLine2">
                                                {{ primaryAddress.addressLine2 }}
                                            </p>
                                            <p class="mb-1">
                                                {{ primaryAddress.town }}<span *ngIf="primaryAddress.region">, {{ primaryAddress.region }}</span>
                                            </p>
                                            <p class="mb-0">
                                                <img *ngIf="getCountryFlag(primaryAddress.countryId)"
                                                     [src]="getCountryFlag(primaryAddress.countryId)"
                                                     class="me-1"
                                                     width="16"
                                                     height="12"
                                                     alt="">
                                                {{ getCountryName(primaryAddress.countryId) }}
                                            </p>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-3 address-action">
                                        <button class="btn btn-outline-primary btn-sm" (click)="editAddress(primaryAddress)">
                                            {{ 'common.edit' | translate }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- IF NO ADDRESS AND NOT SHOWING FORM -->
                            <div *ngIf="!addressLoading && !primaryAddress && !showAddressForm" class="text-center py-3">
                                <div class="alert alert-warning mb-3">
                                    <i class="fa fa-exclamation-triangle me-2"></i>
                                    {{ 'delivery.no_address_warning' | translate }}
                                </div>

                                <button class="btn btn-success add-address-btn" (click)="addAddress()">
                                    <i class="fa fa-plus me-2"></i>
                                    {{ 'delivery.add_address' | translate }}
                                </button>
                            </div>

                            <!-- IF SHOWING FORM (either add or edit) -->
                            <div *ngIf="!addressLoading && showAddressForm">
                                <form *ngIf="addressForm"
                                      [formGroup]="addressForm"
                                      (ngSubmit)="saveAddress()">

                                    <div class="row g-3">
                                        <div class="col-12 col-md-6">
                                            <label>{{ 'common.name' | translate }} <em class="text-danger">*</em></label>
                                            <input type="text" formControlName="name" class="form-control" />
                                            <em *ngIf="addressForm.get('name')?.touched && addressForm.get('name')?.invalid"
                                                class="text-danger validation-message">
                                                {{ 'user_profile.name_required' | translate }}
                                            </em>
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <label>{{ 'user_profile.region' | translate }}</label>
                                            <input type="text" formControlName="region" class="form-control" />
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <label>{{ 'common.country' | translate }} <em class="text-danger">*</em></label>
                                            <select formControlName="countryId"
                                                    class="form-control"
                                                    (change)="onCountryChange($event)">
                                                <option value="">{{ 'common.select_country' | translate }}</option>
                                                <option *ngFor="let c of countries" [value]="c.id">{{ c.nicename }}</option>
                                            </select>
                                            <em *ngIf="addressForm.get('countryId')?.touched && addressForm.get('countryId')?.invalid"
                                                class="text-danger validation-message">
                                                {{ 'common.country_required' | translate }}
                                            </em>
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <label>{{ 'common.town' | translate }} <em class="text-danger">*</em></label>
                                            <select formControlName="town" class="form-control">
                                                <option value="">{{ 'common.select_city' | translate }}</option>
                                                <option *ngFor="let city of cities" [value]="city.cityName">
                                                    {{ city.cityName }}
                                                </option>
                                            </select>
                                            <em *ngIf="addressForm.get('town')?.touched && addressForm.get('town')?.invalid"
                                                class="text-danger validation-message">
                                                {{ 'common.town_required' | translate }}
                                            </em>
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <label>{{ 'user_profile.address_1' | translate }} <em class="text-danger">*</em></label>
                                            <input type="text" formControlName="addressLine1" class="form-control" />
                                            <em *ngIf="addressForm.get('addressLine1')?.touched && addressForm.get('addressLine1')?.invalid"
                                                class="text-danger validation-message">
                                                {{ 'user_profile.address_1_required' | translate }}
                                            </em>
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <label>{{ 'user_profile.address_2' | translate }}</label>
                                            <input type="text" formControlName="addressLine2" class="form-control" />
                                        </div>

                                        <div class="col-12 address-form-actions">
                                            <button type="button"
                                                    class="btn btn-outline-secondary me-2"
                                                    (click)="closeAddressForm()">
                                                {{ 'common.cancel' | translate }}
                                            </button>

                                            <button type="submit"
                                                    class="btn btn-success"
                                                    [disabled]="!addressForm.dirty || addressForm.invalid || savingAddress">
                                                {{ (savingAddress ? 'common.saving' : 'common.save') | translate }}
                                                <span *ngIf="savingAddress">...</span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row delivery-layout">

                <!-- LEFT COLUMN -->
                <div class="col-12 col-lg-8">

                    <div *ngIf="loading" class="text-center py-5">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden">{{ 'common.loading' | translate }}...</span>
                        </div>
                    </div>

                    <div *ngIf="!loading" class="delivery-items">

                        <!-- PRODUCT CARDS -->
                        <div class="card mb-3 product-card" *ngFor="let product of products">
                            <div class="card-body">
                                <div class="product-row">
                                    <div class="product-image-wrapper">
                                        <img [src]="getImageSrc(product.imagePath)"
                                             [alt]="product.name"
                                             class="product-image"
                                             width="60"
                                             height="60">
                                    </div>

                                    <div class="product-info">
                                        <h6 class="mb-0">{{ product.name }}</h6>
                                    </div>

                                    <div class="product-quantity">
                                        <span class="mobile-label">Qty</span>
                                        <span>{{ product.qty }}</span>
                                    </div>

                                    <div class="product-price">
                                        <span class="mobile-label">Price</span>
                                        <span>{{ product.price }} {{ currency | uppercase }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- SHIPPING OPTIONS SECTION -->
                        <div class="shipping-section mt-4">
                            <h6 class="section-heading mb-3">
                                {{ 'delivery.choose_shipping' | translate }}
                            </h6>

                            <div *ngIf="loadingPricing" class="text-center py-3">
                                <div class="spinner-border spinner-border-sm" role="status">
                                    <span class="visually-hidden">{{ 'common.loading' | translate }}...</span>
                                </div>
                            </div>

                            <div *ngIf="!loadingPricing">

                                <div class="card shipping-product-card mb-3" *ngFor="let product of products">

                                    <div class="card-header">
                                        <strong>
                                            <span class="product-icon">📦</span>
                                            {{ product.name }}
                                        </strong>
                                    </div>

                                    <div class="card-body">

                                        <!-- Local Pickup Option -->
                                        <div class="shipping-option-card mb-3 p-3 border rounded"
                                             [class.selected]="isLocalPickupSelected(product.id)"
                                             *ngIf="product.localPickup">

                                            <div class="shipping-option-layout">
                                                <input class="form-check-input shipping-radio"
                                                       type="radio"
                                                       [name]="'shipping-' + product.id"
                                                       [id]="'shipping-local-' + product.id"
                                                       [checked]="isLocalPickupSelected(product.id)"
                                                       (change)="selectLocalPickup(product.id)">

                                                <div class="shipping-option-content">
                                                    <div class="shipping-option-main">
                                                        <strong class="shipping-provider">
                                                            <i class="fa fa-store me-2 text-success"></i>
                                                            {{ 'delivery.local_pickup_option' | translate }}
                                                        </strong>

                                                        <strong class="shipping-price">
                                                            {{ 'delivery.free' | translate }}
                                                        </strong>
                                                    </div>

                                                    <p class="mb-0 text-muted shipping-details">
                                                        <i class="fa fa-map-marker-alt me-1"></i>
                                                        {{ 'delivery.pickup_from_seller' | translate }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Shipping Pricing Options -->
                                        <div *ngIf="hasShippingOptions(product.id)">
                                            <div class="shipping-option-card mb-3 p-3 border rounded"
                                                 [class.selected]="isSelected(product.id, pricing)"
                                                 *ngFor="let pricing of getShippingOptions(product.id)">

                                                <div class="shipping-option-layout">
                                                    <input class="form-check-input shipping-radio"
                                                           type="radio"
                                                           [name]="'shipping-' + product.id"
                                                           [id]="'shipping-' + pricing.id"
                                                           [checked]="isSelected(product.id, pricing)"
                                                           (change)="selectShipping(product.id, pricing)">

                                                    <div class="shipping-option-content">
                                                        <div class="shipping-option-main">
                                                            <strong class="shipping-provider">
                                                                <i class="fa fa-truck me-2 text-success"></i>
                                                                {{ getLogisticAgentLabel(pricing) }}
                                                            </strong>

                                                            <strong class="shipping-price">
                                                                {{ pricing.price }} {{ currency | uppercase }}
                                                            </strong>
                                                        </div>

                                                        <p class="mb-1 mt-1 text-muted shipping-details">
                                                            <i class="fa fa-box me-1"></i>
                                                            {{ pricing.packagingDetails }}
                                                        </p>

                                                        <p class="mb-0 text-muted shipping-date" *ngIf="pricing.eta">
                                                            <i class="fa fa-calendar-alt me-1"></i>
                                                            {{ getDeliveryMessage(pricing.eta) }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="!hasShippingOptions(product.id) && !product.localPickup"
                                             class="text-muted no-shipping-message">
                                            <i class="fa fa-exclamation-triangle me-2"></i>
                                            {{ 'delivery.no_shipping' | translate }}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- RIGHT COLUMN / ORDER SUMMARY -->
                <div class="col-12 col-lg-4">
                    <div class="card order-summary-card">
                        <div class="card-header">
                            <h6 class="mb-0">{{ 'delivery.order_summary' | translate }}</h6>
                        </div>

                        <div class="card-body">
                            <div class="d-flex justify-content-between mb-2 summary-row">
                                <span>{{ 'delivery.items_subtotal' | translate }}:</span>
                                <span>{{ calculateItemsTotal() }} {{ currency | uppercase }}</span>
                            </div>

                            <div class="d-flex justify-content-between mb-2 summary-row">
                                <span>{{ 'delivery.shipping_total' | translate }}:</span>
                                <span>{{ calculateShippingTotal() }} {{ currency | uppercase }}</span>
                            </div>

                            <hr>

                            <div class="d-flex justify-content-between mb-3 summary-total">
                                <strong>{{ 'delivery.total' | translate }}:</strong>
                                <strong>{{ calculateGrandTotal() }} {{ currency | uppercase }}</strong>
                            </div>

                            <div class="summary-actions">
                                <a [routerLink]="['/shopping-cart']" class="text-body back-to-cart">
                                    <i class="fas fa-long-arrow-alt-left me-2"></i>
                                    {{ 'delivery.back_to_cart' | translate }}
                                </a>

                                <button type="button"
                                        class="btn btn-success delivery-next-btn"
                                        [disabled]="!canProceed() || loadingPricing"
                                        (click)="goToCheckout()">
                                    {{ 'delivery.next' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</div>